'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// walrus
import { SVGComponentType } from '../../../kit/svg'

// SVGs
// @ts-ignore
import ChatSVG from './chat.react.svg'
// @ts-ignore
import DashboardSVG from './dashboard.react.svg'
// @ts-ignore
import HomeSVG from './home.react.svg'
// @ts-ignore
import MembersSVG from './members.react.svg'
// @ts-ignore
import OpportunitiesSVG from './opportunities.react.svg'
// @ts-ignore
import SettingsSVG from './settings.react.svg'

/* -----------------------------------------------------------------------------
 * nav icons
 *
 * The tab-bar glyphs the legacy rail used, copied here with their hardcoded
 * red swapped for `fill="replace"`/`stroke="replace"` so the colour comes from
 * a theme prop. The originals in `common` still serve the member app, and
 * their paths carry the red as an attribute, which no prop can override.
 * The dashboard grid has no legacy original and is drawn to match.
 *
 * Keyed by `NavItem.key`.
 * -------------------------------------------------------------------------- */

export const NAV_ICONS: Record<string, SVGComponentType> = {
  chat: ChatSVG,
  dashboard: DashboardSVG,
  home: HomeSVG,
  members: MembersSVG,
  opportunities: OpportunitiesSVG,
  settings: SettingsSVG
}
